import { params } from "@/params";
import { useAuthorizedQuery } from "..";

export function useInteractionEventsAudit<T>(ticketId: string) {
  return useAuthorizedQuery<T>({
    url: `${params.API_URL}/platform/interaction-events/${ticketId}?isTicket=true`,
    queryKey: `getInteractionEvents-${ticketId}`,
    enabled: !!ticketId,
  });
}
